var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPyramidStorygame4 = function SvgIconPyramidStorygame4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.457 11.15H2.543l-.975 1.631a.478.478 0 0 0 .423.719h12.018c.378 0 .614-.4.423-.719l-.975-1.631Z",
    fill: "#9457EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.022 10.35 4.189 8.4h7.622l1.167 1.95H3.022ZM10.166 5.65H5.834L4.667 7.6h6.666l-1.167-1.95ZM8.423 2.737a.497.497 0 0 0-.846 0L6.313 4.85h3.374L8.423 2.737Z",
    fill: "#fff",
    fillOpacity: 0.25
  })));
};
export default SvgIconPyramidStorygame4;